import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import { fetchHomepageIfNeeded } from '../../actions'
import Profile from '../../classes/profile'
import Spinner from '../../components/Spinner'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'

class GroupHomepageContainer extends React.Component {
  static propTypes = {
    profile: Profile.PropTypes,
    homepage: PropTypes.object,
    history: PropTypes.object,
    fetchHomepage: PropTypes.func.isRequired
  }

  componentDidMount () {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (homepage) {
      const homepageId = homepage.details.homepage_entities.filter(e => e.is_default)
      const homepageEntityId = homepageId.length > 0 && homepageId[0].entity_id
      if (homepageEntityId) {
        this.setState({redirectTo: `/insights/homepage/${homepageEntityId}`})
      }
      else {
        this.setState({redirectTo: '/insights/library'})
      }
    } else {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.homepage !== this.props.homepage) {
      if (!this.props.homepage.isFetching) {
        if (this.props.homepage.details && this.props.homepage.details.homepage_entities && this.props.homepage.details.homepage_entities.length > 0) {
          const homepageId = this.props.homepage.details.homepage_entities.filter(e => e.is_default)
          const homepageEntityId = homepageId.length > 0 && homepageId[0].entity_id
          if (homepageEntityId) {
            this.setState({redirectTo: `/insights/homepage/${homepageEntityId}`})
          }
        } else {
          this.setState({redirectTo: '/insights/library'})
        }
      }
    }
  }

  render () {
    if (this.state && this.state.redirectTo) {
      return (<Redirect push to={this.state.redirectTo} />)
    } else {
      return (<Spinner />)
    }
  }
}

const mapStateToProps = () => {
  return (state) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const homepage = state.homepage.list
    return {
      profile,
      homepage
    }
  }
}

function mapDispatchToProps () {
  return (dispatch) => {
    return {
      fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupHomepageContainer)
